import React from "react";

export default function AboutGiulia() {
  return (
    <section id="chi-sono" className="py-24 md:py-32 bg-cream border-y border-chocolate/10 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-16 items-center">
        
        {/* Left: Image with Overlapping Swiss Grid Style */}
        <div className="lg:col-span-5 relative flex justify-center">
          <div className="relative w-full max-w-md aspect-[3/4] border-[3px] border-bordeaux outline outline-1 outline-offset-4 outline-bordeaux/40 overflow-hidden shadow-md z-10 bg-white">
            <img
              src="https://customer-assets.emergentagent.com/job_beyond-toxicity/artifacts/ww3xmowu_G10%20%2854%20di%2064%29%20reduce.jpeg"
              alt="Giulia - Ideatrice di BACK TO YOU"
              className="w-full h-full object-cover object-center hover:scale-102 transition-luxury duration-1000"
            />
          </div>
          {/* Back Card Decoration */}
          <div className="absolute -top-6 -right-6 w-3/4 h-full bg-beige border border-chocolate/10 -z-0 hidden lg:block" />
        </div>

        {/* Right: Text and Narrative */}
        <div className="lg:col-span-7 space-y-8 z-10">
          <div className="space-y-3">
            <span className="text-xs font-semibold uppercase tracking-[0.2em] text-bordeaux">
              {"L'IDEATRICE DEL PERCORSO"}
            </span>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight text-chocolate font-editorial">
              Ciao, sono <span className="italic text-bordeaux">Giulia</span>
            </h2>
          </div>

          <div className="space-y-6 text-chocolate/80 font-light text-sm sm:text-base leading-relaxed font-sans">
            <p>
              {"Ho trascorso anni a studiare la psicologia delle relazioni, la dipendenza affettiva e i meccanismi dell'attaccamento. Ma, prima ancora di essere una professionista, sono stata una donna che ha conosciuto la nebbia, lo svuotamento e la perdita totale dei propri confini."}
            </p>
            <p>
              {"So cosa significa perdersi dentro gli occhi di un uomo, amare partendo da un vuoto e attendere una risposta come se da quella dipendesse il proprio diritto di esistere."}
            </p>
            <p>
              {"Ho creato "} <strong className="font-semibold text-chocolate">BACK TO YOU™</strong> {" e il metodo proprietario "} <strong className="font-semibold text-chocolate">Feminine Return™</strong> {" proprio per questo: per accorciare i tempi e guidare le donne attraverso lo stesso cammino di liberazione che ho dovuto percorrere io stessa, ma con una mappa chiara, sicura e collaudata."}
            </p>
            <p className="italic text-bordeaux font-editorial text-base sm:text-lg">
              {"\"Non meriti un amore che ti fa sentire costantemente instabile o insicura. Meriti di tornare ad essere la regina del tuo regno interiore.\""}
            </p>
          </div>
          
          {/* Core Values row */}
          <div className="grid grid-cols-3 gap-6 pt-6 border-t border-chocolate/10 font-sans">
            <div>
              <h4 className="text-xs font-semibold text-bordeaux uppercase tracking-widest">AUTOREVOLEZZA</h4>
              <p className="text-xs text-chocolate/60 mt-1">{"Nessun compromesso sulla competenza e l'approccio scientifico."}</p>
            </div>
            <div>
              <h4 className="text-xs font-semibold text-bordeaux uppercase tracking-widest">EMPATIA</h4>
              <p className="text-xs text-chocolate/60 mt-1">{"Un ambiente sicuro, caldo e privo di qualunque giudizio."}</p>
            </div>
            <div>
              <h4 className="text-xs font-semibold text-bordeaux uppercase tracking-widest">LUSSO EMOTIVO</h4>
              <p className="text-xs text-chocolate/60 mt-1">{"La cura sartoriale per ogni singola storia e candidata."}</p>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
}
